<div class="pt-100">
    <div class="title-breadcumbs">
        <div class="container">
            <div class="entry-header">
                <h2 class="entry-title">{{"heading-title.product" | translate}}</h2>
            </div>
            <div class="breadcrumb-container">
                <div class="breadcrumbs">
                    <a href="javascript:;">{{"label-title.home" | translate}}</a><span
                        class="separator">&gt;</span><span>{{'heading-title.product' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="category_part ">
    <div class="container">
        @if (helper.userDetails){
            <div class="row">
                <div class="col-12 col-md-3 col-sm-4">
                    <h4 class="mb-3 pb-3">{{'label-title.categories' | translate}}</h4>
                    <div class="d-block d-sm-none"> 
                        <div class="w-100 d-flex justify-content-center mt-2 mb-3">
                            <ng-select class="category-selection-width w-100" id="product-publish-tag" #agreeSelect
                                placeholder="{{ 'label-title.search' | translate }}" [searchable]="true" [clearable]="false"
                                (change)="selectCategoryWiseProductList($event)" [(ngModel)]="selectedCategory">
                                @for(category of categoryList; track $index) {
                                <ng-option [value]="category"> {{ category.name }} <span *ngIf="totalProducts > 0 && category?._id === selectedCategory?._id">({{totalProducts}})</span></ng-option>
                                }
                            </ng-select>
                        </div>
                    </div>
                    <div class="d-none d-sm-block d-md-block"> 
                    <div class="search-box mb-3">
                        <input type="text" class="form-control bg-light border-light"
                            placeholder="{{ 'label-title.search' | translate }}" [(ngModel)]="searchText"
                            name="search" (keyup.enter)="onSearch()" id="product-search" autocomplete="off" />
                        <em class="ri-search-2-line search-icon" triggers="hover"></em>
                        <a href="javascript:void(0);" class="clear-icon" *ngIf="searchText" (click)="clearSearch()">
                            <em class="ri-close-line close-icon"></em>
                        </a>
                    </div>
                    <div class="shoppage-categories">
                        <ul>
                            @for (category of categoryList; track $index) {
                            <li class="shoppage-category-item" [class.active]="category?._id === selectedCategory?._id" (click)="selectCategoryWiseProductList(category)">
                                <a href="javascript:;" class="shoppage-category-link truncate-line-3">{{category.name}} <span *ngIf="totalProducts > 0 && category?._id === selectedCategory?._id">({{totalProducts}})</span></a>
                            </li>
                            }
                        </ul>
                    </div>
                    </div>
                </div>
                <div class="col-12 col-sm-8 col-md-9">
                    <div class="row">
                        <div class="col-12">
                          <div class="toolbar">
                            <div class="toolbar-inner d-flex justify-content-between align-items-center flex-wrap">
                                <p class="woocommerce-result-count mb-0">
                                    {{'label-title.showing' | translate}} {{ (page - 1) * limit + 1 }}– {{ (page * limit) <= totalProducts ? page * limit : totalProducts }} {{'label-title.of' | translate}} {{ totalProducts }} {{'label-title.results' | translate}}
                                  </p>
                                  <div class=" align-items-center mb-0 d-flex " style="flex-wrap: wrap; justify-content: center;">
                                    <label class="me-2"> {{'label-title.sort-by' | translate}}:</label>
                                    <ng-select [(ngModel)]="selectedFilter" [clearable]="false" [searchable]="false" (ngModelChange)="applyFilter()">
                                      <ng-option *ngFor="let option of filters; let i = index" [value]="option.id">
                                        {{ option.name | translate }}
                                      </ng-option>
                                    </ng-select>
                                  </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    <div class="products">
                        <div class="arrrival_items">
                            <div class="row">
                                @for(product of productList; track $index) {
                                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                                        <div class="card">
                                            <div class="card-image product-dual-img image-watermark-wrapper" (mouseenter)="onHover(product)" (mouseleave)="onHoverOut()">
                                                <img class="watermark-main-image" [src]="helper.getImageSrc(hoveredProductId === product._id && product.images?.[0] ? product.images[0] : product.profileImage, helper.DEFAULT_LOGO)" [alt]="product.name || 'KB Imitation jewellery'"
                                                    (error)="helper.handleProductImageError($event)" [class.animate]="hoveredProductId === product._id"/>
                                                <div class="buttons">
                                                    <button class="btn_1 btn_seondary btn-view"
                                                        (click)="viewProduct(product)">{{"button-title.view" | translate}}</button>
                                                </div>
                                                <span class="onsale" *ngIf="product.tags">{{product.tags}}</span>
                                            </div>
                                            <div class="card-body text-center">
                                                <p class="mb-1 truncate-line-3">{{product?.description || '-'}}</p>
                                                <h6 class="truncate-line-2"><a [routerLink]="['/app/product-detail', product._id]">{{product?.name || '-'}}</a></h6>
                                                <p class="price">
                                                    <span *ngIf="product?.discount && product?.discount > 0">
                                                      {{ helper.currency }} {{ helper.getDiscountedPrice(product?.price, product?.discount) | number: '1.0-0' }}
                                                    </span>
                                                    <span *ngIf="product?.discount && product?.discount > 0" class="original-price">
                                                      {{ helper.currency }} {{ product?.price }}
                                                    </span>
                                                    <span *ngIf="!product?.discount || product?.discount === 0">
                                                      {{ helper.currency }} {{ product?.price }}
                                                    </span>
                                                  </p>
                                                <p class="price">{{"label-title.quantity" | translate}} : {{product?.quantity}}</p>
                                            </div>
                                        </div>
                                    </div>
                                }@empty {
                                    <div class="col-12 d-flex justify-content-center align-items-center py-5">
                                        <p>{{'label-title.no-data-found' | translate}}</p>
                                    </div>
                                }
                                
                            </div>
                            @if(productList.length > 0){
                                <div class="text-center mt-2" *ngIf="productList.length < totalProducts">
                                    <a href="javascript:void(0)" class="load-more-link" (click)="loadMoreProducts()">{{"label-title.load-more" | translate}}</a>
                                  </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }@else{
            <div class="col-12 d-flex justify-content-center align-items-center py-5">
                <p>{{'label-title.no-data-found' | translate}}</p>
            </div>
        }
    </div>
</div>

<app-product-detail-modal #productDetailModal></app-product-detail-modal>
<app-auth #authModel (loginEmmiter)="isLogin($event)"></app-auth>
